SupportUtilsHelper = require('../helpers/utils')
SupportPresenterUtilPresentation = require('./presenter_util')

class SupportBasePresentation
  constructor: (order) ->
    @order = order

  getStatus: () ->
    keyPrefix = this.getLookupKeySequence()
    value = SupportPresenterUtilPresentation::lookup(this.getLookupObject(), keyPrefix, SupportPresenterUtilPresentation::STATUS)

    unless value?
      value = @convertToReadableText(@order.STATE)
    value

  getNotes: () ->
    keyPrefix = this.getLookupKeySequence()
    value = SupportPresenterUtilPresentation::lookup(this.getLookupObject(), keyPrefix, SupportPresenterUtilPresentation::NOTES)

    unless value?
      value = ''
    value

  getLookupKeySequence: () ->
    if @order?
      keys = []
      if @canShowGiftInfo()
        keys.push(SupportPresenterUtilPresentation::getGiftDeliveryMethod(@order))
      else if @isGDTOrder()
        keys = SupportPresenterUtilPresentation::getGDTKeys(@order)
      else
        keys.push(SupportPresenterUtilPresentation::getEditableKey(@order.isEditable))
        keys.push(SupportPresenterUtilPresentation::getStatusKey(@order))

      SupportPresenterUtilPresentation::concatenateLookupKeys(keys)

  getLookupObject: () ->
    console.log("No implementation")

  canShowGiftInfo: () ->
    this.isGift(@order) &&
    (SupportPresenterUtilPresentation::getStatusKey(@order) isnt 'REFUNDED')  &&
    (not SupportUtilsHelper.isCurrentOrderGoodsDeal())

  isGift: ->
    @order.isGift && @order.giftInfo

  isGDTOrder: ->
    SupportUtilsHelper.isCurrentOrderLocalDeal() and window.evaluate(@order.deal?.isGDTDeal)

  convertToReadableText: (value) ->
    if !!value
      lowercase = value.toLowerCase()
      pieces = lowercase.split("_")

      words = []
      for piece in pieces
        if !!piece
            words.push(piece.charAt(0).toUpperCase() + piece.slice(1))

      if words.length > 1
        words.join(" ")
      else
        words[0]

module.exports = SupportBasePresentation
